// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "client-editor/" + {"249":"Gallery","505":"Scheduling"}[chunkId] + ".chunk.min.css";
};